import { TWITTER_EVENT_NAME_TO_ID } from "@faire/web-api/indigofair/settings/TWITTER_EVENT_NAME_TO_ID";

import { getSettingValueWithoutAssignment } from "./__internal__/getSetting";

export const getSettingTwitterEventNameToId = (): Partial<
  Record<string, string>
> => getSettingValueWithoutAssignment(TWITTER_EVENT_NAME_TO_ID, {});
